// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"845":"c87ac439","862":"944802f0"}[chunkId] + ".css";
};